/**
 * @module Admin Reports Saga
 * @desc this Reports saga contains the repoers page related generator function's, based upon the action the generator function will be triggered  
 * @return {Object} api's response
 */
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_CHAT_MODAL_DATA,
  GET_CHAT_MODAL_DATA_CLIENT,
  GET_DELETE_TICKET,
  GET_REPORT_LIST,
  GET_REPORT_LIST_FILE_DATA,
  GET_REPORT_LIST_SEARCH,
  POST_ISSUES,
  POST_MODAL_DATA,
  POST_MODAL_DATA_CLIENT,
  UPDATE_REPORT_ISSUE_STATUS
} from "./actionTypes";

import {
  deleteTicketError,
  deleteTicketSuccess,
  getChatModalFail,
  getChatModalSuccess,
  getReportIssuFIleDataFail,
  getReportIssuFIleDataSuccess,
  getReportListFail,
  getReportListSuccess,
  postChatDataFail,
  postChatDataSuccess,
  postIssuesFailure,
  postIssuesSuccessfull,
  updateReportIssuDataFail,
  updateReportIssuDataSuccess
} from "./actions";

import { deleteCall, getCall, getListData, postCall, postStatus } from "../../../helpers/fakebackend_helper";
//restapi end point
import * as constClass from "../../../common/constant/constantURL";

// submit feedback

/** 
   * @property {function} postIssuesHandler function handels the post new issue api, depending upon the respone it will call the action   
   */
function* postIssuesHandler(data) {
  try {
    let url = constClass.REST_API_REPORT_ISSUE;
    let responsJSON = yield call(postCall, url, data.payload);

    yield put(postIssuesSuccessfull(responsJSON));
  } catch (error) {
    yield put(postIssuesFailure(error));
  }
}

/** 
   * @property {function} getReportsListHandler function handels the issue list api, depending upon the respone it will call the action   
   */
function* getReportsListHandler(data) {
  try {
    let dat=data.payload.data
    let url = constClass.REST_API_REPORT_ISSUE+`?page=${dat.pageNumber}&pageSize=${dat.pageSize}`+(dat.searchKeyword !== undefined && dat.searchKeyword !== null && dat.searchKeyword !==""?"&keyword="+dat.searchKeyword:"");
    let responsJSON = yield call(getCall, url);
    yield put( getReportListSuccess(responsJSON));
  } catch (error) {
    yield put(getReportListFail(error));
  }
}

/** 
   * @property {function} getsearchReportListHandler function handels the search issue api, depending upon the respone it will call the action   
   */
function* getsearchReportListHandler({payload: {data}}) {
  try {
    let url = constClass.REST_API_GET_ADMIN_REPORT_LIST+`?page=${data?.pageNumber}&pageSize=${data?.pageSize}`
    if(data.searchKeyword !== undefined && data.searchKeyword !== null && data.searchKeyword !== ""){
      url = constClass.REST_API_GET_ADMIN_REPORT_LIST+`?page=${data?.pageNumber}&pageSize=${data?.pageSize}&keyword=${encodeURIComponent(data.searchKeyword)}`
    }
    
    let responsJSON = yield call(getListData, url);
    yield put( getReportListSuccess(responsJSON));
  } catch (error) {
    yield put(getReportListFail(error));
  }
}

/** 
   * @property {function} getReportIssueFileHandler function handels the issues File data api, depending upon the respone it will call the action   
   */
function* getReportIssueFileHandler({payload: {data}}) {
  try {
    let url = constClass.REST_API_GET_ADMIN_REPORT_LIST+`/${data?.id}/attachment`
    let responsJSON = yield call(getListData, url);
    yield put(getReportIssuFIleDataSuccess(responsJSON));
  } catch (error) {
    yield put(getReportIssuFIleDataFail(error));
  }
}

//update status
/** 
   * @property {function} updateStatusHandler function handels the issue status api, depending upon the respone it will call the action   
   */
function* updateStatusHandler({payload: {data}}) {
  try {
    let url = constClass.REST_API_GET_ADMIN_REPORT_LIST+`/${data.id}/${data.status}`;
    let responsJSON = yield call(postStatus, url);
    yield put(updateReportIssuDataSuccess(responsJSON));
  } catch (error) {
    yield put(updateReportIssuDataFail(error));
  }
}

function* getChatModalHandler({payload: {data}}) {
  try {
    let url = constClass.REST_API_GET_CHAT_MODAL_DATA+`/${data.id}/chat?page=${data.page}&pageSize=${data.pageSize}`;
    let responsJSON = yield call(getListData, url);
    yield put(getChatModalSuccess(responsJSON));
 
  } catch (error) {
    yield put(getChatModalFail(error));
  }
}

function* postChatModalDataHandler({payload: {data}}) {
  try {
    let url = constClass.REST_API_GET_CHAT_MODAL_DATA+`/${data.id}/chat`;
    let responsJSON = yield call(postCall, url, data);
    yield put(postChatDataSuccess(responsJSON));
 
  } catch (error) {
    yield put(postChatDataFail(error));
  }
}

//client
function* getClientChatModalHandler({payload: {data}}) {
  try {
    let url = constClass.REST_AP_GET_REPORT_CHAT_LIST+`/${data.id}/chat?page=${data.page}&pageSize=${data.pageSize}`;
    let responsJSON = yield call(getListData, url);
    yield put(getChatModalSuccess(responsJSON));
 
  } catch (error) {
    yield put(getChatModalFail(error));
  }
}

function* clientpostChatModalDataHandler({payload: {data}}) {
  try {
    let url = constClass.REST_AP_GET_REPORT_CHAT_LIST+`/${data.id}/chat`;
    let responsJSON = yield call(postCall, url, data);
    yield put(postChatDataSuccess(responsJSON));
 
  } catch (error) {
    yield put(postChatDataFail(error));
  }
}

function* deleteTicket(data) {
  try {
    let url = constClass.REST_AP_GET_DELETE_Ticket+`?id=${data.payload}`;
    let responsJSON = yield call(deleteCall, url);
    yield put(deleteTicketSuccess(responsJSON));
 
  } catch (error) {
    yield put(deleteTicketError(error));
  }
}


function* reportIssuesSaga() {
  yield takeEvery(POST_ISSUES, postIssuesHandler);
  yield takeEvery(GET_REPORT_LIST, getReportsListHandler);
  yield takeEvery(GET_REPORT_LIST_SEARCH, getsearchReportListHandler);
  yield takeEvery(GET_REPORT_LIST_FILE_DATA, getReportIssueFileHandler)
  yield takeEvery(UPDATE_REPORT_ISSUE_STATUS, updateStatusHandler)
  yield takeEvery(GET_CHAT_MODAL_DATA, getChatModalHandler)
  yield takeEvery(POST_MODAL_DATA, postChatModalDataHandler)
  //CLIENT
  yield takeEvery( GET_CHAT_MODAL_DATA_CLIENT, getClientChatModalHandler)
  yield takeEvery(POST_MODAL_DATA_CLIENT, clientpostChatModalDataHandler)
  // delete ticket
  yield takeLatest(GET_DELETE_TICKET, deleteTicket)
}

export default reportIssuesSaga
